import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as actions from "../actions/acBookingFlow"
import { BookingFlowStep } from "../actions/acBookingFlow"

import SliderLayout from './SliderLayout'
import BookingFlowAddressSelection from './bookingflow/BookingFlowAddressSelection'
import pootsyWhiteLogo from '../static/img/pootsy-logo-white.png'
import BookingFlowNeeds from "./bookingflow/BookingFlowNeeds"
import BookingFlowDateSelection from "./bookingflow/BookingFlowDateSelection"
import BookingFlowResidenceSelection from "./bookingflow/BookingFlowResidenceSelection"
import BookingFlowSignUpIn from './bookingflow/BookingFlowSignUpIn'
import BookingFlowSodexo from "./bookingflow/BookingFlowSodexo"
import BookingFlowConfirmation from "./bookingflow/BookingFlowConfirmation"
import { Link } from "react-router-dom";
import { parseQuery } from "../helpers/queryHelpers"

let headerSteps = [
	{
		labelKey: 'welcome',
		associatedStep: BookingFlowStep.WELCOME,
		activeForSteps: [
			BookingFlowStep.WELCOME,
			BookingFlowStep.NEEDS,
			BookingFlowStep.AVAILABILITIES,
			BookingFlowStep.INFORMATIONS_SIGN_UP_IN,
			BookingFlowStep.INFORMATIONS_RESIDENCE,
			BookingFlowStep.INFORMATIONS_SODEXO,
			BookingFlowStep.CONFIRMATION]
	},
	{
		labelKey: 'needs',
		associatedStep: BookingFlowStep.NEEDS,
		activeForSteps: [
			BookingFlowStep.NEEDS,
			BookingFlowStep.AVAILABILITIES,
			BookingFlowStep.INFORMATIONS_SIGN_UP_IN,
			BookingFlowStep.INFORMATIONS_RESIDENCE,
			BookingFlowStep.INFORMATIONS_SODEXO,
			BookingFlowStep.CONFIRMATION]
	},
	{
		labelKey: 'availabilities',
		associatedStep: BookingFlowStep.AVAILABILITIES,
		activeForSteps: [
			BookingFlowStep.AVAILABILITIES,
			BookingFlowStep.INFORMATIONS_SIGN_UP_IN,
			BookingFlowStep.INFORMATIONS_RESIDENCE,
			BookingFlowStep.INFORMATIONS_SODEXO,
			BookingFlowStep.CONFIRMATION]
	},
	{
		labelKey: 'informations',
		associatedStep: BookingFlowStep.INFORMATIONS_RESIDENCE,
		activeForSteps: [
			BookingFlowStep.INFORMATIONS_SIGN_UP_IN,
			BookingFlowStep.INFORMATIONS_RESIDENCE,
			BookingFlowStep.INFORMATIONS_SODEXO,
			BookingFlowStep.CONFIRMATION]
	},
	{
		labelKey: 'confirmation',
		associatedStep: BookingFlowStep.CONFIRMATION,
		activeForSteps: [BookingFlowStep.CONFIRMATION]
	}
]

class BookingFlow extends Component {

	componentWillMount() {
		let query = parseQuery(this.props.location.search)
		if (query && query.zip_code) {
			this.props.dispatch(actions.handleUrlParameters(query))
		}
	}

	render() {
		let { t } = this.context
		let { meta } = this.props

		return (
			<div className="BookingFlow">
				<div className="top">
					<Link to="/"><img className="logo" alt="logo" src={pootsyWhiteLogo}/></Link>
					<div className="booking-flow-step-monitor">
						{headerSteps.map((headerStep, i) =>
							<div key={i}
								 data-step={headerStep.associatedStep}
								 className={"step " + headerStep.labelKey + (headerStep.activeForSteps.includes(meta.currentStep) ? " active" : "")}
								 onClick={this.onStepClick}>
								{t(headerStep.labelKey)}
							</div>
						)}
					</div>
				</div>
				{meta.currentStep !== BookingFlowStep.CONFIRMATION ?
					<SliderLayout currentStep={this.mapStepToIndex(meta.currentStep)}>
						{this.renderSteps()}
					</SliderLayout>
					:
					this.renderStep(BookingFlowStep.CONFIRMATION, 8)
				}
			</div>
		)
	}

	renderSteps = () => {
		let steps = this.getSteps()
		return steps.map((step, index) => {
			return this.renderStep(step, index)
		})
	}

	renderStep = (step, key) => {
		switch (step) {
			case BookingFlowStep.WELCOME:
				return <BookingFlowAddressSelection key={key}/>

			case BookingFlowStep.NEEDS:
				return <BookingFlowNeeds key={key}/>

			case BookingFlowStep.AVAILABILITIES:
				return <BookingFlowDateSelection key={key}/>

			case BookingFlowStep.INFORMATIONS_SIGN_UP_IN:
				return <BookingFlowSignUpIn key={key}/>

			case BookingFlowStep.INFORMATIONS_RESIDENCE:
				return <BookingFlowResidenceSelection key={key}/>

			case BookingFlowStep.INFORMATIONS_SODEXO:
				return <BookingFlowSodexo key={key}/>

			case BookingFlowStep.CONFIRMATION:
				return <BookingFlowConfirmation key={key}/>

			default:
				return null
		}
	}

	getSteps = () => {
		let steps = [
			BookingFlowStep.WELCOME,
			BookingFlowStep.NEEDS,
			BookingFlowStep.AVAILABILITIES
		]

		if (!this.props.signedIn) {
			steps.push(BookingFlowStep.INFORMATIONS_SIGN_UP_IN)
		}

		steps.push(
			BookingFlowStep.INFORMATIONS_RESIDENCE,
			BookingFlowStep.INFORMATIONS_SODEXO,
			BookingFlowStep.CONFIRMATION
		)

		return steps
	}

	mapStepToIndex = (step) => {
		let steps = this.getSteps()
		return steps.indexOf(step)
	}

	onStepClick = (e) => {
		let step = e.target.dataset.step
		let keys = Object.keys(BookingFlowStep)
		let currentIndex = keys.indexOf(this.props.meta.currentStep)
		let desiredIndex = keys.indexOf(step)
		if (desiredIndex < currentIndex) {
			this.props.dispatch(actions.bookingFlowMetaChange({ currentStep: step }))
		}
	}
}

BookingFlow.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	meta: state.metadataReducer.bookingFlow,
	signedIn: state.signedIn,
})
export default connect(mapStateToProps)(BookingFlow);



// WEBPACK FOOTER //
// ./src/components/BookingFlow.js